import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendAPI } from '@core/models/backend-api';
import { PackagePlacementsRelation } from '@core/models/package-placements-relation';
import { Package } from '@core/models/package.model';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PackageService {

	constructor (private http: HttpClient) { }

	public getPackagesByPlacement(placementId: string): Observable<Package[]> {
		const url = Location.joinWithSlash(BackendAPI.staticDataPackagesForPlacement, placementId);
		return this.http.get<Package[]>(url);
	}

	public getAllPackages(): Observable<Package[]> {
		const url = BackendAPI.staticDataPackages;
		return this.http.get<Package[]>(url);
	}

	//public getPackagesBuCode(packageCode: string): Observable<Package[]> {
	//	const url = Location.joinWithSlash(BackendAPI.staticDataPackages, packageCode);
	//	return this.http.get<Package[]>(url);
	//}


	public getValidPackagesAndPlacements(): Observable<PackagePlacementsRelation[]> {
		const url = BackendAPI.staticDataValidPackagesAndPlacements;
		return this.http.get<PackagePlacementsRelation[]>(url);
	}
}
